export default __webpack_public_path__ + "static/media/coupon.3c64d55a.svg";